import { gql } from '@provision/graphql-client';
import { USER_SETTING_VALUE_FRAGMENT } from './user-setting-value.fragments';

export const CREATE_USER_SETTING_VALUE_QUERY = gql`
  mutation CreateUserSettingValue($data: UserSettingValueDataInput) {
    createUserSettingValue(data: $data) {
      ...UserSettingValueFields
    }
  }
  ${USER_SETTING_VALUE_FRAGMENT}
`;

export const UPDATE_USER_SETTING_VALUE_QUERY = gql`
  mutation UpdateUserSettingValue(
    $userSettingId: String!
    $userId: String!
    $data: UserSettingValueDataInput
  ) {
    updateUserSettingValue(
      conditions: [
        { attribute: "userSettingId", operator: "=", value: $userSettingId }
        { attribute: "userId", operator: "=", value: $userId }
      ]
      data: $data
    ) {
      ...UserSettingValueFields
    }
  }
  ${USER_SETTING_VALUE_FRAGMENT}
`;
